// @flow

import type { Node } from 'react';

type TProps = {
  setPopupContent: (N: Node) => void
};

const image = '/images/popups/specifications/center_height.gif';

export const Header = 'Center Height';

export function Content ({ setPopupContent }: TProps) {
  return (
    <div>
      <div className="multimedia-box" style={{ margin: 0 }}>
        <img src={image} style={{ display: 'block', margin: '0 auto' }} />
        <div
          className="caption"
          style={{
            marginTop: 0,
            padding: '9px 5px 12px 5px',
            color: '#9b9b9b'
          }}>
          <strong>Center Height</strong> is the distance that the ring extends
          above the finger.
        </div>
      </div>
    </div>
  );
}
